'use client';

import { useTranslations } from 'next-intl';
import type { CelebrationHighlight } from '../celebrationData';

interface HighlightCardsProps {
  highlights: CelebrationHighlight[];
}

export function HighlightCards({ highlights }: HighlightCardsProps) {
  const t = useTranslations('Celebration');

  if (highlights.length === 0) return null;

  return (
    <div>
      {highlights.map((h, i) => (
        <div
          key={i}
          className="flex items-center gap-4 border-b border-[#1B2D4F]/[0.08] py-5 first:border-t lg:gap-5 lg:py-6"
        >
          <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-[#F0EBE0] text-[24px] lg:h-12 lg:w-12">
            {h.icon}
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-[14px] font-extrabold text-[#1B2D4F] lg:text-[16px]">
              {t(h.labelKey as Parameters<typeof t>[0])}
            </div>
            <div className="mt-0.5 truncate text-[12px] text-[#8B95A5] lg:text-[13px]">
              {h.detail}
            </div>
          </div>
          <div
            className="flex-shrink-0 text-right text-[36px] leading-none text-[#1B2D4F] lg:text-[48px]"
            style={{ fontFamily: 'var(--font-anton)' }}
          >
            {h.value}
          </div>
        </div>
      ))}
    </div>
  );
}
